var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmaterialCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "#C44536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-cancel",
    d: "M15.5,3A12.5,12.5,0,1,0,28,15.5,12.489,12.489,0,0,0,15.5,3Zm6.25,16.987L19.987,21.75,15.5,17.262,11.012,21.75,9.25,19.987,13.738,15.5,9.25,11.012,11.012,9.25,15.5,13.738,19.987,9.25l1.763,1.762L17.263,15.5Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialCancel);
export default __webpack_public_path__ + "static/media/Icon material-cancel.ed67bf40398b33dd0afa5083ec03661a.svg";
export { ForwardRef as ReactComponent };